import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  MILLISECONDS_IN_SEC,
  MINUTES_IN_HOUR,
  SECONDS_IN_MIN,
} from '../utilities/constants/time';

export const useTimer = (defaultTime = SECONDS_IN_MIN) => {
  const [timeLeft, setTimeLeft] = useState<number>(defaultTime);
  const [temporalyDisableResendActions, setTemporalyDisableResendActions] =
    useState<boolean>(false);

  useEffect(() => {
    let interval: NodeJS.Timer;
    if (temporalyDisableResendActions) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(+interval);
            setTemporalyDisableResendActions(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, MILLISECONDS_IN_SEC);
    }
    return () => clearInterval(+interval);
  }, [temporalyDisableResendActions]);

  return {
    timeLeft,
    temporalyDisableResendActions,
    setTimeLeft,
    setTemporalyDisableResendActions,
  };
};

export const useCountdown = (targetTime: moment.MomentInput) => {
  const [currentTime, setCurrentTime] = useState(moment());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment());
    }, MILLISECONDS_IN_SEC);

    return () => clearInterval(timer);
  }, []);

  if (!targetTime) {
    return {
      timer: '00:00',
      isExpired: true,
      time: { hours: 0, minutes: 0, seconds: 0 },
    };
  }

  const target = moment(targetTime);
  const diffTime = target.diff(currentTime);
  const isExpired = diffTime <= 0;

  if (isExpired) {
    return {
      timer: '00:00',
      isExpired: true,
      time: { hours: 0, minutes: 0, seconds: 0 },
    };
  }

  const duration = moment.duration(diffTime);
  const totalSeconds = Math.floor(duration.asSeconds());

  const hours = Math.floor(totalSeconds / (SECONDS_IN_MIN * MINUTES_IN_HOUR));
  const minutes = Math.floor(
    (totalSeconds % (SECONDS_IN_MIN * MINUTES_IN_HOUR)) / SECONDS_IN_MIN,
  );
  const seconds = totalSeconds % SECONDS_IN_MIN;

  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');
  const formattedHours = hours > 0 ? `${String(hours).padStart(2, '0')}:` : '';

  const timer = `${formattedHours}${formattedMinutes}:${formattedSeconds}`;

  return {
    timer,
    isExpired: false,
    time: {
      hours,
      minutes,
      seconds,
    },
  };
};
